module.exports = __webpack_public_path__ + "media/images/users-3e67ec8f9cbdd87dfa4e998955af9333.svg";